import { render, staticRenderFns } from "./egrMain.vue?vue&type=template&id=4a7161ee&scoped=true&"
import script from "./egrMain.vue?vue&type=script&lang=js&"
export * from "./egrMain.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a7161ee",
  null
  
)

export default component.exports